import lazyLoad from '@utils/lazyLoad'

const notificationSet = [
  {
    path: '/store/notification_set',
    exact: true,
    component: lazyLoad(() => import('@views/NotificationSet/index'))
  }
]

export default notificationSet
